import { IResponse, encryptedRequest } from "../core/api.client";

export interface IConsentLoginReadResponse {
  consentResponseInfo: Array<{
    isConsentAvailable: string;
    partnerDisplayName: string;
    partnerLegalName: string;
  }>;
  mobileNo: string;
}

export interface IConsentLoginApiResponse {
  data: Record<string, unknown> | null;
  statusCode: number;
  status: string;
  message: string;
}

const consentLoginRead = async (
  mobileNo: string,
  consentList: Array<{
    consentId: string;
    consentCategory: string;
  }>
): Promise<IResponse<IConsentLoginReadResponse>> => {
  try {
    const response = await encryptedRequest<IConsentLoginReadResponse>({
      method: "POST",
      url: "/api/v2/consent-read",
      data: {
        mobileNo,
        consentInfo: consentList,
      },
    });
    if (response.statusCode !== 90) {
      throw new Error(response?.message);
    }
    return response;
  } catch (err) {
    throw new Error(`Error in login consent-read API: ${err}`);
  }
};

const consentLoginInsert = async (
  mobileNo: string,
  consentIdList: Array<string>,
  consentStatus: string
): Promise<IResponse<Record<string, unknown>>> => {
  try {
    const response = await encryptedRequest<Record<string, unknown>>({
      method: "POST",
      url: "/api/v2/consent-insert",
      data: {
        mobileNo,
        consentIdList,
        consentStatus,
        firstName: "",
        lastName: "",
      },
    });
    if (response.statusCode !== 90) {
      throw new Error(response?.message);
    }
    return response;
  } catch (err) {
    throw new Error(`Error in login consent-insert API: ${err}`);
  }
};

export { consentLoginRead, consentLoginInsert };
